import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'whiteboards.ncs-announcement-banner.body.do-not-translate': {
    id: 'whiteboards.ncs-announcement-banner.body.do-not-translate',
    defaultMessage:
      'We’re dogfooding a major refactor of the collaboration architecture. If anything doesn’t look right, please let us know in <link>#whiteboards-ncs-feedback</link>',
    description:
      'Announcement banner shown during the NCS refactor rollout, inviting users to contact the team via Slack if they hit issues. <link> wraps the Slack channel link.',
  },
  'whiteboards.ncs-announcement-banner.dismiss.do-not-translate': {
    id: 'whiteboards.ncs-announcement-banner.dismiss.do-not-translate',
    defaultMessage: 'Dismiss announcement',
    description:
      'Accessible label for the button that dismisses the NCS refactor announcement banner.',
  },
});
